import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-ceg-agreement',
  templateUrl: './ceg-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CegAgreementComponent extends AgreementsDateBaseDirective {
}
